import React from 'react';
import { observer } from 'mobx-react';
import { Spring, animated } from 'react-spring';

import Button from 'js/components/common/Button';

export default observer(props => (
  <Spring native from={{ opacity: 0 }} to={{ opacity: 1 }}>
    {animation => (
      <animated.div style={animation}>
        <Button {...props} />
      </animated.div>
    )}
  </Spring>
));
